function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { sdkLogger } from '../../../logger';
import { PlayerState } from '@sky-uk-ott/vpt-abr';
import { VideoElementEventType } from '../shaka.enums';
var _obj;
var videoElementEventMap = (_obj = {}, _define_property(_obj, VideoElementEventType.ended, PlayerState.STOPPED), _define_property(_obj, VideoElementEventType.seeking, PlayerState.SEEKING), _define_property(_obj, VideoElementEventType.play, PlayerState.PLAYING), _define_property(_obj, VideoElementEventType.pause, PlayerState.PAUSED), _obj);
export var AbrToShakaWrapper = /*#__PURE__*/ function() {
    "use strict";
    function AbrToShakaWrapper(player) {
        _class_call_check(this, AbrToShakaWrapper);
        _define_property(this, "player", void 0);
        _define_property(this, "playerStateEventListeners", void 0);
        _define_property(this, "playbackRateEventListeners", void 0);
        _define_property(this, "logger", void 0);
        this.player = player;
        this.playerStateEventListeners = [];
        this.playbackRateEventListeners = [];
        this.logger = sdkLogger.withContext('ShakaToAbr');
        var videoElement = this.player.getMediaElement();
        if (!videoElement) {
            throw new Error('Tried to create AbrToShakaWrapper with no video element');
        }
        var eventType;
        for(eventType in videoElementEventMap){
            var playerState = videoElementEventMap[eventType];
            videoElement.addEventListener(eventType, this.playerEventHandler.bind(this, playerState));
        }
        videoElement.addEventListener('ratechange', this.playbackRateChanged.bind(this));
    }
    _create_class(AbrToShakaWrapper, [
        {
            key: "onPlaybackRateChanged",
            value: function onPlaybackRateChanged(callback) {
                this.playbackRateEventListeners.push(callback);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var videoElement = this.player.getMediaElement();
                var eventType;
                for(eventType in videoElementEventMap){
                    var playerState = videoElementEventMap[eventType];
                    videoElement === null || videoElement === void 0 ? void 0 : videoElement.removeEventListener(eventType, this.playerEventHandler.bind(this, playerState));
                }
            }
        },
        {
            key: "getBufferedInfo",
            value: function getBufferedInfo() {
                var videoElement = this.player.getMediaElement();
                if (!videoElement) {
                    this.logger.warn('Tried to get buffered info with no video element');
                    return {
                        currentTime: 0,
                        buffer: []
                    };
                }
                var bufferedInfo = this.player.getBufferedInfo();
                return {
                    currentTime: (videoElement === null || videoElement === void 0 ? void 0 : videoElement.currentTime) | 0,
                    buffer: bufferedInfo.total
                };
            }
        },
        {
            key: "onPlayerStateChanged",
            value: function onPlayerStateChanged(callback) {
                this.playerStateEventListeners.push(callback);
            }
        },
        {
            key: "setRetryPolicy",
            value: function setRetryPolicy(retryConfig) {
                var streamingConfig = {
                    streaming: {
                        retryParameters: _object_spread({}, retryConfig)
                    }
                };
                this.player.configure(streamingConfig);
            }
        },
        {
            key: "playerEventHandler",
            value: function playerEventHandler(playerState) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.playerStateEventListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var handler = _step.value;
                        handler(playerState);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "playbackRateChanged",
            value: function playbackRateChanged() {
                var mediaElement = this.player.getMediaElement();
                if (!mediaElement) {
                    return;
                }
                var rate = mediaElement.playbackRate;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.playbackRateEventListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var handler = _step.value;
                        handler(rate);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return AbrToShakaWrapper;
}();

//# sourceMappingURL=abr-to-shaka-wrapper.js.map